import React from "react";
import DatasetTabs from "./DatasetTabs";
import DataViewBulkDownloadControls from "./DataViewBulkDownloadControls";
import DataViewDetailPanelToggle from "./DataViewDetailPanelToggle";
import DataViewSearchControls from "./DataViewSearchControls";
import CompanyBulkActions from "./CompanyBulkActions";
import CompanyAttachActions from "./CompanyAttachActions";

const DataViewHeroSection = ({
  activeConfig,
  searchInput,
  onSearchInputChange,
  onSearchSubmit,
  onClearSearch,
  selectedStatus,
  onStatusChange,
  showDocStatusFilter,
  pagination,
  onPerPageChange,
  pageSizeOptions,
  listLoading,
  showMassDownloadControls,
  modeConfig,
  selectedRows,
  isSearchMode,
  batchOptions,
  selectedBatchValue,
  onSelectedBatchChange,
  isBulkDownloading,
  bulkDownloadDisabled,
  primaryDownloadLabel,
  onBulkDownload,
  downloadError,
  batchSize,
  showCompanyBulkActions = false,
  showCompanyAttachActions = false,
  companyBulkSelectedRows = [],
  companyAttachSelectedRows = [],
  isMergingCompanies = false,
  isDeletingCompanies = false,
  companyBulkError = "",
  onMergeCompanies,
  onDeleteCompanies,
  onSearchCompanies,
  onAttachCompany,
  datasets,
  activeDataset,
  configByDataset,
  onDatasetChange,
  detailPanelPosition,
  detailPanelPositions,
  onDetailPanelPositionChange,
}) => {
  return (
    <section className="overflow-hidden rounded-[1.8rem] border border-slate-800/80 bg-[radial-gradient(circle_at_top_left,_rgba(56,189,248,0.10),_transparent_30%),radial-gradient(circle_at_top_right,_rgba(16,185,129,0.10),_transparent_28%),linear-gradient(180deg,_rgba(15,23,42,0.98),_rgba(6,10,18,0.99))] p-6 shadow-[0_30px_90px_rgba(2,6,23,0.72)] backdrop-blur sm:p-8">
      <div className="flex flex-col gap-6">
        <div className="flex flex-col gap-6 xl:flex-col xl:items-start xl:justify-between">
          <div className="w-full flex-1">
            <div className="rounded-[1.4rem] border border-slate-800/80 bg-slate-950/60 p-5 shadow-[inset_0_1px_0_rgba(255,255,255,0.03)] sm:p-6">
              <div className="mb-4 flex flex-col gap-1">
                <h2 className="text-lg font-semibold tracking-tight text-white">
                  Search {activeConfig.label}
                </h2>
              </div>

              <DataViewSearchControls
                activeLabel={activeConfig.label}
                searchInput={searchInput}
                onSearchInputChange={onSearchInputChange}
                onSubmit={onSearchSubmit}
                onClear={onClearSearch}
                selectedStatus={selectedStatus}
                onStatusChange={onStatusChange}
                showDocStatusFilter={showDocStatusFilter}
                perPage={pagination.per_page}
                onPerPageChange={onPerPageChange}
                pageSizeOptions={pageSizeOptions}
                disabled={listLoading}
              />

              <DataViewBulkDownloadControls
                show={showMassDownloadControls}
                modeConfig={modeConfig}
                selectedRows={selectedRows}
                isSearchMode={isSearchMode}
                batchOptions={batchOptions}
                selectedBatchValue={selectedBatchValue}
                onSelectedBatchChange={onSelectedBatchChange}
                isBulkDownloading={isBulkDownloading}
                bulkDownloadDisabled={bulkDownloadDisabled}
                primaryDownloadLabel={primaryDownloadLabel}
                onBulkDownload={onBulkDownload}
                downloadError={downloadError}
                batchSize={batchSize}
              />
              <CompanyBulkActions
                show={showCompanyBulkActions}
                selectedRows={companyBulkSelectedRows}
                isMerging={isMergingCompanies}
                isDeleting={isDeletingCompanies}
                error={companyBulkError}
                onMerge={onMergeCompanies}
                onDelete={onDeleteCompanies}
              />
              <CompanyAttachActions
                show={showCompanyAttachActions}
                selectedRows={companyAttachSelectedRows}
                isAttaching={isMergingCompanies}
                error={companyBulkError}
                onSearchCompanies={onSearchCompanies}
                onAttachCompany={onAttachCompany}
              />
            </div>
          </div>

          <div className="w-full xl:mt-1">
            <div className="flex w-full flex-col gap-4 lg:flex-row lg:items-start xl:items-end">
              <div className="min-w-0 flex-1">
                <DatasetTabs
                  datasets={datasets}
                  activeDataset={activeDataset}
                  configByDataset={configByDataset}
                  onChange={onDatasetChange}
                  disabled={false}
                />
              </div>

              <DataViewDetailPanelToggle
                detailPanelPosition={detailPanelPosition}
                detailPanelPositions={detailPanelPositions}
                onChange={onDetailPanelPositionChange}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DataViewHeroSection;
